import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function OwnerProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-brand-violet text-white/70">Caricamento...</div>;
  }
  if (!user) return <Navigate to="/owner/login" replace />;
  if (user.role !== "owner") return <Navigate to="/admin" replace />;
  return children;
}
